export const FETCH_END = 'doneLoading'
export const FETCH_START = 'setLoading'

export const PUSH_START = 'setUpdating'
export const PUSH_END = 'doneUpdating'

export const SET_ERROR = 'setError'
export const CLEAR_ERROR = 'clearError'

export const PURGE_AUTH = 'purgeAuth'
export const SET_AUTH = 'setUser'
export const SET_PROFILE = 'setProfile'
export const RESET_STATE = 'resetModuleState'

export const SET_USERS = 'setUsers'
